import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { DISPLAY_MODES } from 'site-modules/shared/constants/incentives/electric-car-incentives';

export const CardsList = memo(({ dataTrackingParent, displayMode, activeDisplayMode, children = null }) => {
  return (
    <ul
      className={classnames('row list-unstyled no-focus', { 'd-none': displayMode !== activeDisplayMode })}
      data-tracking-parent={dataTrackingParent}
    >
      {children}
    </ul>
  );
});

CardsList.displayName = 'CardsList';

CardsList.propTypes = {
  dataTrackingParent: PropTypes.string.isRequired,
  activeDisplayMode: PropTypes.oneOf(DISPLAY_MODES).isRequired,
  displayMode: PropTypes.oneOf(DISPLAY_MODES).isRequired,
  children: PropTypes.node,
};
